/**
 * 学习乐园 · 连连看题材包：生肖配地支（lianliankan/pack-shengxiao.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：生肖连地支（「鼠」连「子」）。固定 12 对——生肖就十二个，
 * 多一个是编的；棋盘随之缩成 6×4=24 格，一局更短（栏目「三分钟」口径）。
 * note 是干支合称（「子鼠」），消除与配错反馈时都展示：配对的同时记住
 * 「子丑寅卯」这套顺序，而不是死记图案。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.shengxiao = {
    id: 'shengxiao',
    name: '生肖配地支',
    hint: '鼠连子、牛连丑，十二对全在这',
    kind: 'rel',
    cols: 6,
    rows: 4,
    pairs: [
      { l: '鼠', r: '子', note: '子鼠' },
      { l: '牛', r: '丑', note: '丑牛' },
      { l: '虎', r: '寅', note: '寅虎' },
      { l: '兔', r: '卯', note: '卯兔' },
      { l: '龙', r: '辰', note: '辰龙' },
      { l: '蛇', r: '巳', note: '巳蛇' },
      { l: '马', r: '午', note: '午马' },
      { l: '羊', r: '未', note: '未羊' },
      { l: '猴', r: '申', note: '申猴' },
      { l: '鸡', r: '酉', note: '酉鸡' },
      { l: '狗', r: '戌', note: '戌狗' },
      { l: '猪', r: '亥', note: '亥猪' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
